"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var factor_convert_1 = require("../lib/factor-convert");
var distance_conversions_1 = require("./distance-conversions");
function convert(input, targetUnits) {
    return {
        quantity: factor_convert_1.factorConvert(input.quantity, distance_conversions_1.findConversionFactor(input.unit), distance_conversions_1.findConversionFactor(targetUnits)),
        unit: targetUnits,
        type: "distance",
    };
}
exports.convert = convert;
//# sourceMappingURL=convert-distance.js.map